<template>
  <section
    id="home"
    class="section"
    :class="{ play: isInView }"
    data-pv="index"
  >
    <div class="section__outer"></div>
    <div class="section__inner">
      <Kv data-section="kv"></Kv>
      <Slugger data-section="slugger"></Slugger>
      <Scout data-section="scout"></Scout>
      <Overview data-section="overview"></Overview>
      <Entry data-section="entry"></Entry>
      <Protect></Protect>

      <div class="fixed-btn">
        <!-- <div class="fixed-btn__item">
          <a
            href="https://www.ctbcinvestments.com/act/202506_Natixis/usa_growth_202507.pdf"
            target="_blank"
          ></a>
        </div> -->
        <div
          class="fixed-btn__item"
          @click.prevent="scrollToElement('store')"
        ></div>
        <div
          class="fixed-btn__item"
          id="gotop"
          @click.prevent="scrollToTop"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';
import { mixins } from '@/utils/mixins';

import Kv from '@/components/Kv.vue';
import Slugger from '@/components/Slugger.vue';
import Scout from '@/components/Scout.vue';
import Overview from '@/components/Overview.vue';
import Entry from '@/components/Entry.vue';
import Protect from '@/components/Protect.vue';

export default {
  name: 'Home',
  mixins: [mixins],
  props: {},
  watch: {
    isLoading() {
      this.init();
    },
  },
  data: () => {
    return {
      isInView: false,
    };
  },
  computed: {
    ...mapState(useMainStore, ['isLoading']),
  },
  methods: {
    // ...mapActions(useMainStore, []),
    init() {
      this.isInView = true;
    },
    testLink(path) {
      this.$router.push(path);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    observerSections() {
      // 如果已經有observer先清除
      if (this.observer) {
        this.observer.disconnect();
      }

      const sections = [
        { name: 'kv', category: 'KV', label: 'KV' },
        { name: 'slugger', category: 'section1', label: 'Greatagain' },
        { name: 'scout', category: 'section2', label: 'MLB' },
        { name: 'overview', category: 'section3', label: 'Feature' },
        { name: 'entry', category: 'section4', label: 'Information' },
      ];
      const options = {
        root: null,
        threshold: 0.1,
      };

      // 紀錄已觸發的區塊
      const triggeredSections = new Set();

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sectionName = entry.target.getAttribute('data-section');
            const section = sections.find((s) => s.name === sectionName);
            if (!triggeredSections.has(sectionName)) {
              const section = sections.find((s) => s.name === sectionName);
              if (section) {
                this.$trackEvent(
                  'section_view',
                  section.category,
                  section.label
                );
                triggeredSections.add(sectionName);
              }
            }
          }
        });
      }, options);

      sections.forEach((section) => {
        const element = document.querySelector(
          `[data-section="${section.name}"]`
        );
        if (element) {
          this.observer.observe(element);
        }
      });
    },
    scrollToElement(id) {
      // const element = document.querySelector(`#${id}`);
      const element = document.getElementById(id);
      const header = document.getElementById('header');

      if (element) {
        // 使用 getBoundingClientRect 計算精確位置
        const headerHeight = header ? header.offsetHeight : 0;
        const offsetTop =
          element.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    },
  },
  created() {},
  mounted() {
    // const { init, isLoading } = this;
    // setTimeout(() => { if (!isLoading) init() }, 1000)
    this.$nextTick(() => {
      this.observerSections();
    });
  },
  destroyed() {},
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  components: {
    Kv,
    Slugger,
    Scout,
    Overview,
    Entry,
    Protect,
  },
};
</script>

<style lang="scss">
$assets: '~@/assets/images/home/';

#home {
  overflow: hidden;
  background-color: #fff;

  .section__inner {
    height: 100%;
  }

  .test-block {
    margin-top: 20px;
    display: flex;
    flex-direction: column;

    a {
      margin-top: 10px;
    }
  }

  .wrap {
    width: 1400px;
    position: relative;
    margin: 0 auto;
    @include tabletX {
      width: 100%;
      max-width: vwX(1400);
      padding: 0 vwX(50);
    }
    @include tablet {
      width: vwM(960);
      padding: 0 vwM(10);
    }
  }
  .table-box {
    width: 1302px;
    background-color: #fff;
    border: 4px solid #009eb5;
    position: relative;
    z-index: 3;
    margin: 0 auto;
    padding: 37px 70px 90px 70px;
    @include tabletX {
      width: 100%;
      max-width: 1302px;
      padding: vwX(37) vwX(70) vwX(90) vwX(70);
    }
    @include tablet {
      width: vwM(960);
      border: vwM(6) solid #009eb5;
      padding: vwM(28);
    }
    &.table-box--border {
      border-bottom: 20px solid #009eb5;
      @include tablet {
        border-bottom: vwM(20) solid #009eb5;
      }
      &.table-box--border--purple {
        border-bottom: 20px solid #64117d;
        @include tablet {
          border-bottom: vwM(20) solid #64117d;
        }
      }
    }
    &.table-box--purple {
      border: 4px solid #64117d;
      @include tablet {
        border: vwM(6) solid #64117d;
      }
    }
  }
  .section__title-img {
    width: 100%;
    background-repeat: no-repeat;
    background-position: center top;
    position: absolute;
    left: 0;
  }
  .section__title {
    font-size: 42px;
    line-height: 2.1;
    letter-spacing: (letterSpacing(100, 42px));
    color: #fff;
    position: relative;
    z-index: 2;
    margin-left: 49px;
    @include tabletX {
      width: 100%;
      max-width: 1302px;
      font-size: vwX(42);
      letter-spacing: (letterSpacing(100, vwX(42)));
      margin: 0 auto;
    }
    @include tablet {
      font-size: vwM(58);
      letter-spacing: letterSpacing(100, vwM(58));
      font-weight: 400;
      margin-left: unset;
    }
    &::before {
      display: inline-block;
      content: '';
      width: 82px;
      height: 82px;
      background-image: url('../assets/images/cross_icon.png');
      background-repeat: no-repeat;
      background-size: 82px 82px;
      background-position: center top;
      position: absolute;
      top: -44px;
      left: -32px;
      @include tablet {
        width: vwM(115);
        height: vwM(115);
        background-size: vwM(115) vwM(115);
        top: vwM(-62);
        left: vwM(-45);
      }
    }
    span {
      display: inline-block;
      height: 75px;
      background-color: #009eb5;
      font-weight: 400;
      line-height: 75px;
      padding: 0 50px 0 50px;
      @include tabletX {
        height: vwX(75);
        line-height: vwX(75);
        padding: 0 vwX(50) 0 vwX(50);
      }
      @include tablet {
        height: vwM(105);
        line-height: vwM(105);
        padding: 0 vwM(58);
      }
    }
    .section__span--bold {
      font-size: 50px;
      font-weight: 600;
      @include tabletX {
        font-size: vwX(50);
      }
      @include tablet {
        font-size: vwM(70);
      }
    }
    .section__span--purple {
      background-color: #64117d;
    }
  }
  .table-box__title {
    font-size: 42px;
    color: #009eb5;
    letter-spacing: letterSpacing(120, 42px);
    margin: 86px 0 0 22px;
    @include tabletX {
      font-size: vwX(42);
      letter-spacing: letterSpacing(120, vwX(42));
      margin: vwX(86) 0 0 vwX(22);
    }
    @include tablet {
      font-size: vwM(50);
      letter-spacing: vwM(letterSpacing(120, 50));
      margin: vwM(86) 0 0 vwM(29);
    }
    &::after {
      display: block;
      content: '';
      width: 180px;
      height: 4px;
      background-color: #009eb5;
      margin-top: 18px;
      @include tabletX {
        width: vwX(180);
        height: vwX(4);
        margin-top: vwX(18);
      }
      @include tablet {
        width: 23.5%;
        height: vwM(4);
        margin-top: vwM(38);
      }
    }
    &.table-box__title--purple {
      color: #64117d;
      &::after {
        background-color: #64117d;
      }
    }
  }
  .sub-title {
    font-weight: 500;
    position: relative;
    margin: 80px 0 60px 87px;
    @include tablet {
      margin: vwM(85) 0 vwM(65) vwM(127);
    }
    &::before {
      display: inline-block;
      content: '';
      width: 94px;
      height: 119px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center top;
      position: absolute;
      top: -24px;
      left: -77px;
      @include tablet {
        width: vwM(132);
        height: vwM(167);
        top: vwM(-24);
        left: vwM(-115);
      }
    }
    &.sub-title-1 {
      &::before {
        background-image: url('../assets/images/num1_blue.png');
      }
    }
    &.sub-title-2 {
      &::before {
        background-image: url('../assets/images/num2_blue.png');
        top: -15px;
        @include tablet {
          top: vwM(-30);
        }
      }
    }
    p:nth-child(1) {
      font-size: 38px;
      color: #009eb5;
      letter-spacing: (letterSpacing(120, 38px));
      @include tablet {
        font-size: vwM(53);
        letter-spacing: (letterSpacing(120, vwM(53)));
      }
    }
    p:nth-child(2) {
      font-size: 29px;
      color: #3f3f3f;
      letter-spacing: (letterSpacing(60, 29px));
      margin-top: 13px;
      @include tablet {
        font-size: vwM(41);
        letter-spacing: (letterSpacing(60, vwM(41)));
        margin-top: vwM(15);
      }
    }
  }
  .chart {
    // overflow-x: auto;
    display: flex;
    justify-content: center;
    width: 100%;
    // max-width: 1150px;
    // margin-left: 23px;
    @include tabletX {
      // margin-left: vwX(23);
    }
    @include tablet {
      // width: vwM(975);
      // margin-left: 0;
    }
    img {
      background-color: #ffffff;
      border: none;
      @include tablet {
        border: vwM(2) solid #e8e8e8;
        // box-sizing: content-box;
        box-sizing: border-box;
        padding: vwM(20) vwM(15) vwM(20) vwM(15);
      }
    }
  }
  .common-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 594px;
    height: 51px;
    background-color: #fff;
    font-size: 21px;
    letter-spacing: (letterSpacing(80, 21px));
    color: #3f3f3f;
    border: 4px solid #009eb5;
    @include tabletX {
      width: vwX(594);
      height: vwX(51);
      font-size: vwX(21);
      letter-spacing: (letterSpacing(80, vwX(21)));
    }
    @include tablet {
      width: vwM(804);
      height: vwM(75);
      background-color: #fff;
      font-size: vwM(30);
      letter-spacing: (letterSpacing(80, vwM(30)));
      border: vwM(6) solid #009eb5;
    }
  }
  .secure-text {
    width: 1105px;
    font-size: 17px;
    font-weight: 600;
    color: #3f3f3f;
    text-align: justify;
    line-height: lineHeight(17, 25);
    letter-spacing: letterSpacing(100, 17px);
    margin: 48px auto 0 auto;
    @include tabletX {
      width: vwX(1105);
    }
    @include tablet {
      width: vwM(840);
      font-size: 23px;
      line-height: lineHeight(23, 35);
      letter-spacing: letterSpacing(100, 18px);
      margin: vwM(48) auto 0 auto;
    }
    @include mobile {
      font-size: vwMB(23);
    }
  }
  .inactive {
    display: none;
    @include tablet {
      display: inline-block;
    }
  }
  .inactive--opposite {
    display: block;
    @include tablet {
      display: none;
    }
  }
  .inactive--block {
    display: none;
    @include tablet {
      display: block;
    }
  }
  .comma {
    display: inline-block;
    margin: 0 -30px 0 -21px;
    @include tabletX {
      margin: 0 vwX(-30) 0 vwX(-21);
    }
    @include tablet {
      display: none;
    }
  }

  .fixed-btn {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    position: fixed;
    top: 66vh;
    right: 94px;
    z-index: 10;
    @include tablet {
      right: vwM(50);
    }
    .fixed-btn__item {
      width: 90px;
      height: 90px;
      background-size: 90px 90px;
      background-repeat: no-repeat;
      background-position: center top;
      @include tablet {
        width: vwM(132);
        height: vwM(132);
        background-size: vwM(132) vwM(132);
      }
      cursor: pointer;
      // &:nth-child(1) {
      //   background-image: url('../assets/images/dm_icon.png');
      //   a {
      //     display: block;
      //     width: 90px;
      //     height: 90px;
      //     @include tablet {
      //       width: vwM(132);
      //       height: vwM(132);
      //     }
      //   }
      // }
      &:nth-child(1) {
        background-image: url('../assets/images/store_icon.png');
        margin-top: 14px;
        @include tablet {
          margin-top: vwM(16);
        }
      }
      &:nth-child(2) {
        background-image: url('../assets/images/top_icon.png');
        margin-top: 14px;
        @include tablet {
          margin-top: vwM(16);
        }
      }
    }
  }

  .tabs {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;
    background-color: #e5f5f7;
    position: relative;
    cursor: pointer;
  }

  .tab-content {
    min-height: 800px;
    padding: 135px 40px 110px 40px;
    @include tablet {
      min-height: vwM(800);
      padding: vwM(135) vwM(28) vwM(120) vwM(28);
    }
    .tab-content__title {
      font-size: 38px;
      font-weight: 500;
      color: #009eb5;
      text-align: center;
      letter-spacing: letterSpacing(120, 38px);
      line-height: lineHeight(38, 45);
      margin-left: 20px;
      // @include tabletX {
      //   font-size: vwX(38);
      //   text-align: left;
      //   letter-spacing: letterSpacing(120, vwX(38));
      //   line-height: lineHeight(38, 60);
      //   margin-left: vwX(20);
      // }
      @include tablet {
        font-size: vwM(55);
        text-align: left;
        letter-spacing: letterSpacing(110, vwM(55));
        line-height: lineHeight(55, 64);
        margin-left: vwM(33);
      }
    }
    .tab-content__discript {
      font-size: 21px;
      font-weight: 600;
      color: #626262;
      text-align: center;
      letter-spacing: letterSpacing(120, 21px);
      line-height: lineHeight(21, 33);
      margin: 18px 0 0 20px;
      @include tablet {
        font-size: vwM(29);
        text-align: left;
        letter-spacing: letterSpacing(120, vwM(29));
        line-height: lineHeight(29, 50);
        margin: vwM(42) 0 0 vwM(33);
      }
    }
    .tab-content__chart {
      display: flex;
      justify-content: center;
      position: relative;
      margin-top: 6px;
      // @include tabletX {
      //   justify-content: flex-start;
      // }
      @include tablet {
        margin-top: vwM(48);
        // padding-right: vwM(20);
      }
      img {
        @include tablet {
          // box-sizing: content-box;
          box-sizing: border-box;
          // padding: vwM(94) vwM(40) vwM(30) vwM(40);
        }
      }
      // .tab-content__chart-text {
      //   font-size: 17px;
      //   font-weight: 400;
      //   color: #626262;
      //   transform: translate(-50%, 0);
      //   position: absolute;
      //   left: 50%;
      //   @include tabletX {
      //     font-size: vwX(17);
      //   }
      //   @include tablet {
      //     font-size: vwM(24);
      //   }
      // }
    }
  }
  .tab-content__chart-text {
    font-size: 17px;
    font-weight: 400;
    color: #626262;
    transform: translate(-50%, 0);
    position: absolute;
    left: 50%;
    @include tabletX {
      font-size: vwX(17);
    }
    @include tablet {
      font-size: vwM(24);
    }
  }
}
</style>
